export const TransactionSwipeThreshold = 100;
